import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/ic_tips_gray.png';
import _imports_1 from '@/assets/imgs/ic_fresh.png';
import _imports_2 from '@/assets/imgs/ic_tips.png';

const _withScopeId = n => (_pushScopeId("data-v-2fd2b532"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "demandcontent-warp"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "cms-card-block"
};
const _hoisted_4 = {
  class: "buttons mg-b--15"
};
const _hoisted_5 = {
  key: 0,
  style: {
    "margin": "0 12px"
  }
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mg-l--10",
  style: {
    "cursor": "pointer"
  },
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1));

const _hoisted_7 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_8 = {
  key: 0,
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "cursor": "pointer"
  },
  src: _imports_2,
  alt: "",
  srcset: ""
}, null, -1));

const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  style: {
    "width": "100%",
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_12 = ["onClick"];
import dayjs from 'dayjs';
import axios from 'axios';
import DialogProgress from '@/components/DialogProgress/index.vue';
import ActionHeader from '@/views/common/ActionHeader/index.vue';
import Buttons from '@/components/Buttons/index.vue';
import AddFilm from './AddFilm.vue';
import AddSeries from './AddSeries.vue';
import MovieOrDramaCheck from '@/views/onDemandContent/FilmReview/Check/index.vue';
import SeriesCheck from '@/views/onDemandContent/SeriesFilm/Check/index.vue';
import PaidContent from './PaidContent.vue';
import ManuallyUpload from '@/components/Upload/ManuallyUpload.vue';
import SearchInput from '@/components/SearchInput/index.vue';
import { usePageConfig } from '@/utils/useComponentConfig';
import { useRouter, useRoute } from 'vue-router';
import { RELEASE_STATUS_NEW } from '@/assets/config/dicts';
import { useI18n } from 'vue-i18n';
import { useBroadCastList, useGenresList } from '@/utils/cacheData';
import { useCommon } from '@/store/useCommon';
import { debounce, downBase64File, downloadFile, getItemByProp, getUrlParams } from '@/utils/tools';
import { onMounted, inject, provide, nextTick } from 'vue';
import { elMessage, getTextWidth } from '@/utils';
import { messageBox } from '@/utils/validate';
import { axiosInstance } from '@/api/instance';
import { getCurrentTime } from '@/utils/timeFormat';
import { isConsecutive } from '@/utils/tools';
import { getVodInfoListApi, sortByNameApi, removeVodInfoApi, changeSequenceVodInfoApi } from '@/api/vodNew';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    returnBackFn: {
      type: Function
    }
  },

  setup(__props) {
    const props = __props;
    const storeCommon = useCommon();
    const {
      t
    } = useI18n();
    const route = useRoute();
    const router = useRouter();
    const tableRef = ref(null);
    const rowItemInfo = inject('rowItemInfo');
    const tooltipContent = ref(t('快速双击排序序号,在输入框编辑排序'));
    const addFilm = reactive({
      visible: false
    });
    const addSeries = reactive({
      visible: false
    });
    const paidContent = reactive({
      visible: false
    });
    const dialogProgress = reactive({
      visible: false
    });
    const movieOrDramaCheck = reactive({
      visible: false
    });
    const seriesCheck = reactive({
      visible: false
    });
    const detailInfo = reactive({
      id: '',
      programType: ''
    }); // 导入进度条

    const importPercentage = ref(0);
    let cancelAxios = ref(axios.CancelToken.source());
    const dialogProgressRef = ref(null); // 搜索框配置

    const searchConfig = reactive({
      formData: {
        programName: ''
      },
      formList: [{
        label: '关键字',
        prop: 'programName',
        widgetType: 'input',
        placeholder: '请输入关键字',
        style: "width: 260px"
      }],
      search: () => {
        tableRef.value.commonTableRef.clearSelection();
        getVodInfoList();
      },
      reset: () => {
        tableConfig.paginationConfig.page = 1;
        onRefresh();
      }
    });
    const headerConfig = ref({
      title: '内容列表',
      btnList: [{
        label: '返回',
        func: () => {
          // closeSelectedTag(route)
          props.returnBackFn();
        }
      }]
    }); // 返回关闭标签

    const closeSelectedTag = view => {
      storeCommon.delTagsView({ ...view
      });
      router.push({
        path: '/operating/product-operating/on-demand',
        query: getUrlParams(route)
      });
    };

    const selectTableConfig = reactive({
      selectData: [] // table已勾选的数据列表

    });
    provide('selectTableConfig', selectTableConfig); // table复选框点击事件

    const handleSelectionChange = val => {
      selectTableConfig.selectData = val;
    };

    const tableConfig = reactive({
      data: [],
      isShowHeader: false,
      isCardBlock: false,
      scrollbarAlwaysOn: true,
      paginationConfig: usePageConfig(),
      headerButtonsList: [{
        label: '添加点播',
        func: () => {
          // router.push('/operating/product-operating/on-demand/add-film')
          addFilm.visible = true;
        },
        controller: () => {
          return rowItemInfo.type == 'movie' || rowItemInfo.type == 'tv_series';
        }
      }, {
        label: '添加系列',
        func: () => {
          // router.push('/operating/product-operating/on-demand/add-series')
          addSeries.visible = true;
        },
        controller: () => {
          return rowItemInfo.type == 'video_series' && rowItemInfo.type !== 'default';
        }
      }, {
        label: '影片付费编辑',
        func: () => {
          if (selectTableConfig.selectData.length === 0) {
            return elMessage('warning', '请先勾选需要批量操作的影片');
          } else {
            let idx = selectTableConfig.selectData.findIndex(item => item.programType === 'video_series');
            if (idx > -1) return elMessage('warning', '选中系列片内容不支持付费编辑');
            paidContent.visible = true;
          } // router.push('/operating/product-operating/on-demand/paid-content')

        },
        controller: config => {
          // 勾选了分类取消禁用的逻辑
          // config.disabled = !tableConfig.data.length || !selectTableConfig.selectData.length ? true : false;
          // return true;
          return rowItemInfo.type !== 'video_series';
        }
      }, {
        label: '移除',
        func: () => {
          if (selectTableConfig.selectData.length === 0) {
            return elMessage('warning', '请选择至少一条数据');
          } else {
            const ids = selectTableConfig.selectData.map(item => item.id);
            removeVodInfo(ids);
          }
        },
        controller: config => {
          config.disabled = !tableConfig.data.length || !selectTableConfig.selectData.length ? true : false;
          return true;
        }
      }, {
        label: '导入电影',
        cellSlot: true,
        prop: 'movie',
        func: () => {},
        uploadFile: file => {
          dialogProgress.visible = true;
          cancelAxios.value = axios.CancelToken.source();
          setTimeout(() => {
            handleImportFile(file, 0);
          }, 100);
        },
        controller: () => {
          return rowItemInfo.type == 'movie';
        }
      }, {
        label: '导入连续剧',
        cellSlot: true,
        prop: 'drama',
        func: () => {},
        uploadFile: file => {
          dialogProgress.visible = true;
          cancelAxios.value = axios.CancelToken.source();
          setTimeout(() => {
            handleImportFile(file, 1);
          }, 100);
        },
        controller: () => {
          return rowItemInfo.type == 'tv_series';
        }
      }, {
        label: '按名称排序',
        cellSlot: true,
        prop: 'sortByName',
        func: debounce(async btn => {
          if (rowItemInfo.id) {
            const sequenceLists = selectTableConfig.selectData.map(item => item.sequence);

            if (isConsecutive(sequenceLists)) {
              messageBox(`${t('操作后内容列表会按名称字母重新排序，确认操作吗?')}`).then(async () => {
                btn.loading = true;
                tableConfig.config.loading = true;

                try {
                  const ids = selectTableConfig.selectData.map(item => item.id); // 按名称重新排序后，清除排序条件，避免出问题

                  sortParams = {
                    sortType: '',
                    sortField: ''
                  };
                  const res = await sortByNameApi({
                    categoryId: rowItemInfo.id,
                    programId: ids,
                    programType: rowItemInfo.type
                  });

                  if (res.code == '0') {
                    // ElMessageBox.alert(t('按名称排序成功'), t('提示'), {
                    //   confirmButtonText: t('确定'),
                    //   callback: (action) => {
                    //     getVodInfoList(() => btn.loading = false)
                    //   },
                    // })
                    elMessage('success', '操作成功');
                    tableRef.value.commonTableRef.clearSelection();
                    getVodInfoList(() => btn.loading = false);
                  } else {
                    btn.loading = false;
                    tableConfig.config.loading = false;
                  } // else {
                  //   ElMessageBox.alert(t('按名称排序失败'), t('提示'), {
                  //     confirmButtonText: t('确定'),
                  //     callback: (action) => {
                  //       btn.loading = false
                  //       tableConfig.config.loading = false
                  //     },
                  //   })
                  // }

                } catch (error) {
                  elMessage('error', '系统错误'); // ElMessageBox.alert(t('按名称排序失败'), t('提示'), {
                  //   confirmButtonText: t('确定'),
                  //   callback: (action) => {
                  //     btn.loading = false
                  //     tableConfig.config.loading = false
                  //   },
                  // })

                  btn.loading = false;
                  tableConfig.config.loading = false;
                }
              });
            } else {
              return elMessage('error', '不满足连续选中');
            }
          }
        }, 200),
        controller: config => {
          config.disabled = !tableConfig.data.length || selectTableConfig.selectData.length == 1 ? true : false;
          return rowItemInfo.type !== 'default';
        }
      }],
      config: {
        loading: false
      },
      columnList: [{
        label: '',
        prop: '',
        type: 'selection',
        'reserve-selection': true
      }, {
        label: '排序',
        prop: 'sequence',
        widgetType: 'sortDoubleInput',
        width: 100,
        onValueChange: async (newValue, oldValue, done, rowData) => {
          // console.log(newValue, oldValue, rowData);
          if (newValue === oldValue) {
            done();
            return;
          } else {
            try {
              const {
                id
              } = rowData;
              const params = {
                //categoryId: rowItemInfo.id,
                id,
                sequence: newValue //sequenceBefore: oldValue

              };
              const res = await changeSequenceVodInfoApi(params);

              if (res.code == '0') {
                elMessage('success', '操作成功');
                tableRef.value.commonTableRef.clearSelection();
                getVodInfoList();
              } else {
                rowData.sequence = oldValue;
              }
            } catch (error) {
              rowData.sequence = oldValue;
            }

            done();
          }
        },
        miximum: 0,
        controller: () => {
          return rowItemInfo.type !== 'default';
        }
      }, {
        label: 'IMDB ID',
        prop: 'sourceId',
        width: 160,
        sortable: 'custom'
      }, {
        label: '分类名称',
        prop: 'categoryName',
        width: 160,
        sortable: 'custom'
      }, {
        label: '内容类型',
        prop: 'programType',
        width: 160,
        sortable: 'custom',
        formatter: value => {
          return value == 'tv_series' ? t('剧集') : value == 'movie' ? t('单片') : value == 'video_series' ? t('系列片') : '';
        }
      }, {
        label: '内容名称',
        prop: 'programName',
        width: 260,
        sortable: 'custom',
        cellSlot: true,
        showOverflowTooltip: false
      }, {
        label: '付费形式',
        prop: 'paymentForm',
        width: 162,
        sortable: 'custom',
        formatter: value => {
          return value == 'vip' ? t('VIP内容') : value == 'single_pay' ? t('付费单片') : value == 'free' ? t('免费内容') : '';
        },
        controller: () => {
          return rowItemInfo.type !== 'video_series';
        }
      }, {
        label: '分类属性',
        prop: 'genres',
        width: 160,
        sortable: 'custom' // formatter: (value: any) => {
        //   return formateStr(value, genresList.value)
        // }

      }, {
        label: '语言',
        prop: 'mediaContentLanguage',
        width: 120,
        sortable: 'custom'
      }, {
        label: '更新时间',
        prop: 'updateTime',
        width: 160,
        sortable: 'custom'
      }, {
        label: '上线状态',
        prop: 'releaseStatus',
        width: 160,
        sortable: 'custom',
        formatter: value => {
          if (value !== undefined && value !== null) return RELEASE_STATUS_NEW[value];
        }
      }, {
        label: '分辨率',
        prop: 'resolution',
        width: 163
      }, {
        label: '创建时间',
        prop: 'createTime',
        width: 160,
        sortable: 'custom',
        formatter: val => val && getCurrentTime(val),
        controller: () => {
          return rowItemInfo.type == 'default';
        }
      }, {
        label: '发布时间',
        prop: 'releaseTime',
        width: 160,
        sortable: 'custom',
        formatter: val => val && getCurrentTime(val)
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        showOverflowTooltip: false,
        fixed: 'right',
        buttonsList: [{
          label: '移除',
          func: row => {
            const {
              id
            } = row;
            removeVodInfo([id]);
          }
        }]
      }],
      'row-key': row => {
        return row.id;
      }
    }); // 移除点播内容item

    const removeVodInfo = async ids => {
      messageBox(rowItemInfo.type == 'default' ? '确认将内容移除子品牌, 移除后内容关联子品牌的其他分类也会将内容移除。' : '确定删除所选数据吗?').then(async () => {
        try {
          let res = await removeVodInfoApi(ids);

          if (res.code == '0') {
            elMessage('success', '删除成功');
            tableRef.value.commonTableRef.clearSelection();
            getVodInfoList();
          }
        } catch (error) {}
      });
    };

    const cid = ref(sessionStorage.getItem('productOperationsCid'));

    const handleImportFile = async (file, type) => {
      let params = new FormData();
      params.append('file', file.raw);
      params.append('ids', [rowItemInfo.id]);
      params.append('cid', cid.value);
      params.append('cpspId', sessionStorage.getItem('currentCpspid') ? Number(sessionStorage.getItem('currentCpspid')) : useCommon().userData.cpspid || 0);

      if (type === 0) {
        try {
          const res = await axiosInstance({
            method: 'post',
            url: '/api/category/importMovie',
            data: params,
            type: 'upload',
            duration: 5000,
            timeout: 1800000,
            cancelToken: cancelAxios.value.token,
            onUploadProgress: progress => {
              // 上传进度--格式化成百分数
              let progressVal = Math.floor(progress.loaded / progress.total * 100) > 0 ? Math.floor(progress.loaded / progress.total * 100) : importPercentage.value;
              importPercentage.value = progressVal === 100 ? 99 : progressVal;
            }
          });

          if (res.code === '0') {
            importPercentage.value = 100;
            setTimeout(() => {
              onPercentageSuccess();
              elMessage('success', '操作成功');
              tableRef.value.commonTableRef.clearSelection();
            }, 200);
          } else {
            dialogProgressRef.value.changeShowText(t('导入失败'));
            importPercentage.value = 100;

            if (res.code == 'B0002') {
              downloadFile(res.data);
            } else if (res.code == 'B0003') {
              downloadFile(res.data);
            } else if (res.code == 'B0004') {
              downBase64File(res.data, `Movies_${dayjs(new Date()).format('YYYY_MM_DD')}`);
            }
          }
        } catch (error) {
          if (axios.isCancel(error)) {
            elMessage('warning', 'Upload has been canceled');
            importPercentage.value = 0;
          } else {
            elMessage('warning', 'Upload error, please upload again.');
            importPercentage.value = 0;
          }
        }
      } else {
        try {
          const res = await axiosInstance({
            method: 'post',
            url: '/api/category/importSeries',
            data: params,
            type: 'upload',
            duration: 5000,
            timeout: 1800000,
            cancelToken: cancelAxios.value.token,
            onUploadProgress: progress => {
              // console.log(progress);
              // console.log(Math.floor(progress.loaded / progress.total * 100));
              // 上传进度--格式化成百分数
              let progressVal = Math.floor(progress.loaded / progress.total * 100) > 0 ? Math.floor(progress.loaded / progress.total * 100) : importPercentage.value;
              importPercentage.value = progressVal === 100 ? 99 : progressVal;
            }
          });

          if (res.code === '0') {
            importPercentage.value = 100;
            setTimeout(() => {
              onPercentageSuccess();
              elMessage('success', '操作成功');
              tableRef.value.commonTableRef.clearSelection();
            }, 200);
          } else {
            dialogProgressRef.value.changeShowText(t('导入失败'));
            importPercentage.value = 100;

            if (res.code == 'B0002') {
              downloadFile(res.data);
            } else if (res.code == 'B0003') {
              downloadFile(res.data);
            } else if (res.code == 'B0004') {
              downBase64File(res.data, `Series_${dayjs(new Date()).format('YYYY_MM_DD')}`);
            }
          }
        } catch (error) {
          if (axios.isCancel(error)) {
            elMessage('warning', 'Upload has been canceled');
            importPercentage.value = 0;
          } else {
            elMessage('warning', 'Upload error, please upload again.');
            importPercentage.value = 0;
          }
        }
      }
    }; // 取消导入


    const onPercentageCancel = done => {
      if (cancelAxios.value) {
        cancelAxios.value.cancel();
        importPercentage.value = 0;
      }

      done();
    }; // 导入完成


    const onPercentageSuccess = () => {
      dialogProgress.visible = false;
      getVodInfoList();
    };

    const broadCastList = ref([]); // 获取分辨率

    const getBroadCastList = async () => {
      const res = await useBroadCastList();
      broadCastList.value = res;
    };

    getBroadCastList(); // 默认更新时间倒序

    let sortParams = reactive({
      sortType: 'desc',
      sortField: 'releaseTime'
    }); // 获取列表数据

    const getVodInfoList = async done => {
      tableConfig.config.loading = true;

      try {
        // console.log('rowItemInfo', rowItemInfo)
        let params = {
          categoryId: rowItemInfo.type == 'default' ? undefined : rowItemInfo.id,
          subAgentId: rowItemInfo.type == 'default' ? rowItemInfo.id : undefined,
          pageNo: tableConfig.paginationConfig.page,
          pageSize: tableConfig.paginationConfig.limit,
          ...sortParams,
          ...searchConfig.formData //cpspid: sessionStorage.getItem('currentCpspid') ? Number(sessionStorage.getItem('currentCpspid')) : useCommon().userData.cpspid || ''

        };
        const res = await getVodInfoListApi(params);

        if (res.code == '0') {
          tableConfig.data = res.data ? res.data : [];
          tableConfig.paginationConfig.total = res.total;
          const item = getItemByProp(tableConfig.columnList, 'sequence');
          item.maximum = res.total;
        }
      } catch (error) {
        tableConfig.config.loading = false;
      }

      setTimeout(() => {
        done && done();
        tableConfig.config.loading = false;
      }, 200);
    };

    const genresList = ref([]); // 获取分类属性

    const getGenres = async () => {
      const language = localStorage.getItem('language') || 'en';
      const res = await useGenresList(language, 0);
      const res1 = await useGenresList(language, 1);
      setTimeout(() => {
        let resArr = [...res, ...res1];
        let obj = {};
        genresList.value = resArr.reduce((item, next) => {
          obj[next.id] ? '' : obj[next.id] = true && item.push(next);
          return item;
        }, []);
      }, 200);
    };

    provide('genresList', genresList);

    const setOptionsBtnColumnWidth = width => {
      const findItem = tableConfig.columnList.find(item => item.label == '操作');
      findItem.width = width;
    };

    onMounted(() => {
      getVodInfoList();
      getGenres();
    }); // 表格排序

    const handleSortChange = debounce(async params => {
      if (params.order) {
        const sortType = params.order.replace('ending', '');
        sortParams.sortType = sortType;
        sortParams.sortField = params.prop;
        getVodInfoList();
      } else {
        onRefresh();
      }
    }, 200);

    const onRefresh = () => {
      sortParams.sortType = 'desc';
      sortParams.sortField = 'releaseTime';
      tableRef.value.commonTableRef.clearSelection();
      tableRef.value.commonTableRef.clearSort();
      getVodInfoList();
    };

    const onProgramNameClick = row => {
      console.log('row', row);
      const {
        programId,
        programType
      } = row;
      detailInfo.id = programId;
      detailInfo.programType = programType;
      programType == 'video_series' ? seriesCheck.visible = true : movieOrDramaCheck.visible = true;
    }; //  内容超出时显示提示


    const tipDisabled = ref(false);

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText, {
        fontSize: '14px'
      });
      tipDisabled.value = target.offsetWidth < width;
    };

    const filterColumnItemChange = () => {
      nextTick(() => {
        tableRef.value && tableRef.value.commonTableRef.doLayout();
      });
    };

    watch(() => [addFilm.visible, addSeries.visible, paidContent.visible], val => {
      if (val[0] === false && val[1] === false && val[2] === false) {
        tableConfig.paginationConfig.page = 1;
        selectTableConfig.selectData = [];
        getVodInfoList();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_tooltip = _resolveComponent("el-tooltip");

      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");

      const _component_MPopper = _resolveComponent("MPopper");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [!addFilm.visible && !addSeries.visible && !paidContent.visible && !movieOrDramaCheck.visible && !seriesCheck.visible ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(ActionHeader, {
        config: headerConfig.value
      }, null, 8, ["config"]), _createVNode(SearchInput, {
        class: "cms-card-block",
        labelWidth: "120px",
        size: {
          xs: 24,
          sm: 24,
          md: 12,
          lg: 12,
          xl: 12
        },
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: searchConfig.search,
        onReset: searchConfig.reset
      }, null, 8, ["form-list", "form-data", "onSearch", "onReset"]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(Buttons, {
        class: "header__btns",
        "buttons-list": tableConfig.headerButtonsList
      }, {
        cellSlot: _withCtx(scope => [scope.prop == 'movie' || scope.prop == 'drama' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(ManuallyUpload, {
          limit: 1,
          cover: "",
          fileType: ['xlsx', 'xls'],
          accept: ".xlsx,.xls",
          "show-file-list": false,
          onHandleChange: scope.uploadFile
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(scope.prop == 'movie' ? _ctx.$t('导入电影') : _ctx.$t('导入连续剧')), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["onHandleChange"])])) : _createCommentVNode("", true), scope.prop == 'sortByName' ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: _normalizeStyle(_unref(rowItemInfo).type == 'movie' || _unref(rowItemInfo).type == 'tv_series' ? '' : 'margin: 0 12px')
        }, [_createVNode(_component_el_button, {
          type: "primary",
          disabled: !tableConfig.data.length || selectTableConfig.selectData.length == 1 ? true : false,
          onClick: $event => scope.func(scope)
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('按名称排序')), 1), _createVNode(_component_el_tooltip, {
            "popper-class": "self-popper",
            placement: "top",
            effect: "light"
          }, {
            default: _withCtx(() => [_hoisted_6]),
            content: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_ctx.$t('1、未勾选内容点击排序，可以将全部内容按名称重新排序；')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('2、连续选中多个内容点击排序，只对选中内容按名称重新排序；')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('注意：选中内容不满足连续选中无法排序。')), 1)]),
            _: 1
          })]),
          _: 2
        }, 1032, ["disabled", "onClick"])], 4)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["buttons-list"]), _createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
        onClick: onRefresh,
        class: "pointer",
        src: _imports_1,
        alt: ""
      }), _createVNode(_component_TableColumnOptionBtn, {
        "column-list": tableConfig.columnList,
        onFilterColumnItemChange: filterColumnItemChange
      }, null, 8, ["column-list"])])]), _createVNode(_component_common_table, {
        dynamicOption: "",
        onSetOptionsBtnColumnWidth: setOptionsBtnColumnWidth,
        style: {
          "width": "100%"
        },
        ref_key: "tableRef",
        ref: tableRef,
        "pagination-config": tableConfig.paginationConfig,
        "table-config": tableConfig,
        render: getVodInfoList,
        onSelectionChange: handleSelectionChange,
        onSortChange: _unref(handleSortChange)
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": tableConfig.columnList
        }, {
          title: _withCtx(column => [column.nodeDate.prop == 'sequence' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(_ctx.$t(column.label)), 1), _createVNode(_component_el_tooltip, {
            "popper-class": "self-popper",
            content: tooltipContent.value,
            placement: "top",
            effect: "light"
          }, {
            default: _withCtx(() => [_hoisted_9]),
            _: 1
          }, 8, ["content"])])) : _createCommentVNode("", true)]),
          cellSlot: _withCtx(scope => [scope.column.property == 'programName' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_MPopper, {
            disabled: tipDisabled.value,
            placement: "top",
            trigger: "hover",
            content: scope.row.programName
          }, {
            reference: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", {
              onMouseover: showTextTip,
              style: {
                "display": "inline-block",
                "white-space": "nowrap",
                "overflow": "hidden",
                "text-overflow": "ellipsis",
                "width": "100%"
              },
              class: "link",
              onClick: $event => onProgramNameClick(scope.row)
            }, _toDisplayString(scope.row.programName), 41, _hoisted_12)])]),
            _: 2
          }, 1032, ["disabled", "content"])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["pagination-config", "table-config", "onSortChange"])])), [[_directive_loading, tableConfig.config.loading]])])) : _createCommentVNode("", true), addFilm.visible ? (_openBlock(), _createBlock(AddFilm, {
        key: 1,
        returnBackFn: () => addFilm.visible = false
      }, null, 8, ["returnBackFn"])) : _createCommentVNode("", true), addSeries.visible ? (_openBlock(), _createBlock(AddSeries, {
        key: 2,
        returnBackFn: () => addSeries.visible = false
      }, null, 8, ["returnBackFn"])) : _createCommentVNode("", true), paidContent.visible ? (_openBlock(), _createBlock(PaidContent, {
        key: 3,
        returnBackFn: () => paidContent.visible = false
      }, null, 8, ["returnBackFn"])) : _createCommentVNode("", true), _createVNode(DialogProgress, {
        ref_key: "dialogProgressRef",
        ref: dialogProgressRef,
        modelValue: dialogProgress.visible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogProgress.visible = $event),
        percentage: importPercentage.value,
        onOnCancel: onPercentageCancel
      }, null, 8, ["modelValue", "percentage"]), _createVNode(MovieOrDramaCheck, {
        modelValue: movieOrDramaCheck.visible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => movieOrDramaCheck.visible = $event),
        "detail-info": _unref(detailInfo),
        showAuditStatus: false,
        "header-title": "查看",
        cid: cid.value,
        onUpdateList: getVodInfoList
      }, null, 8, ["modelValue", "detail-info", "cid"]), _createVNode(SeriesCheck, {
        modelValue: seriesCheck.visible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => seriesCheck.visible = $event),
        "detail-info": _unref(detailInfo),
        cid: cid.value,
        onUpdateList: getVodInfoList
      }, null, 8, ["modelValue", "detail-info", "cid"])]);
    };
  }

});